<template>
	
	<el-container>
		<el-header>
			<img @click="backHome" width="16rem" src="../assets/iconBack.png"/>
			<img style="margin-left: 2rem;" width="150rem" src="../assets/logo.png"/>
		</el-header>
		  <el-main>
			  <div class="bg">
				  <div class="bgT">Attention!</div>
				  <img width="200rem" src="../assets/iconError.png"/>
				  <div style="display: flex;flex-direction: column;align-items: center;font-size: 1.2em;width: 80%;text-align: center;font-family: ago4;">
					  What you bought may be a fake, please contact our official sales.
				  </div>
			  </div>
			  <div style="display: flex;flex-direction: column;align-items: center;padding: 2rem;font-size: .9em;font-family: ago3;font-weight: 600;">
				  <div>RADIANT FUTURES, INFINITE BEAUTY: </div>
				  <div>IGNITE YOUR JOURNEY</div>
			  </div>
			  <CustomerLogos />
		  </el-main>
		  <el-footer>
		  </el-footer>
	</el-container>
</template>

<script>
	import CustomerLogos from '@/components/CustomerLogos.vue';
	export default {
	  name: 'App',
	  components: {
	    CustomerLogos
	  },
	  methods:{
		  backHome(){
			  this.$router.push({ path: '/Home' });
		  }
	  }
	};
</script>

<style scoped>
	.bgT{
		font-size: 3em;
		font-family: ago2;
		font-weight: 400;
	}

		.el-header{
			 background-image: url('../assets/bg1.png');
			 background-size: 100% 100%;
			 color: #333;
			 text-align: center;
			 width: 100%;
			 margin: 0;
			 padding: 0;
			 display: flex;
			 align-items: center;
			 height: 10vh;
			 padding: 0 1rem;
		}
		.el-main{
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0;
			margin-top: 5vh;
		}
		.bg{
			background-image: url('../assets/bg2.png');
			background-size: 100% 100%;
			width: 90%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			padding: 3rem 0;
			gap: 2rem;
		}
		.el-footer{
			background-image: url('../assets/bg1.png');
			background-size: 100% 100%;
			height: 5vh!important;
			width: 100%;
		}
</style>